import type { ButtonConfig } from '../../declare'
import { useContext } from 'react'
import { Button } from 'antd'
import { EasyIcon, ListPropsContext } from 'src/components'
import { searchStore, listStore } from 'src/stores'

type Props = {
  config: ButtonConfig
}

const CustomRenderBtn = (props: Props) => {
  const listProps = useContext(ListPropsContext)
  const search = searchStore.search.get(listProps.formCode)
  const table = listStore.table.get(listProps.formCode)

  if (table?.dynamicJs[props.config.CLICK_EVENT] instanceof Function) {
    return table.dynamicJs[props.config.CLICK_EVENT](search, table, props)
  }

  const { LABEL, ICON } = props.config
  return <Button type='primary' icon={<EasyIcon type={ICON} defaultIcon='FileTextOutlined' />}>{LABEL}</Button>
}

export default CustomRenderBtn